<template src="./terms.html"></template>

<script>
  export default {}
</script>

<style>

</style>
